<template>
  <div id="app">
    <div class="container-fluid" v-if="profile">
      <div id="wrapper" class="active" :class="{ 'on-mobile': $store.state.chat.isMobileMode }">
        <div class="row">
          <div class="col-fixed-90" v-if="!$store.state.chat.isMobileMode && isOnMobile">
            <transition enter-active-class="uk-animation-fade">
              <sidebar />
            </transition>
          </div>
          <div
            v-if="$store.state.chat.isMobileMode && isOnMobile"
            :class="{'fixe-sidebar': $store.state.chat.isMobileMode}"
          >
            <transition enter-active-class="uk-animation-fade">
              <sidebar-mobile />
            </transition>
          </div>
          <div
            class="col-fixed-listbar"
            id="contect"
            :class="{ 'on-mobile':  $store.state.chat.isMobileMode }"
          >
            <transition name="component-fade" mode="out-in" v-if="isOnMobile">
              <router-view />
            </transition>
          </div>
          <div
            class="col-lg-12 col-offset-msg"
            id="chatbox"
            :class="{ 'on-mobile':  $store.state.chat.isMobileMode }"
          >
            <transition name="component-fade" mode="out-in">
              <chat-box v-if="activeChatCustomer" />
            </transition>
            <transition name="slide-fade">
              <profile-info v-if="customerContact"></profile-info>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Sidebar from './components/Sidebar.vue';
import ChatBox from './components/ChatBox.vue';
import ProfileInfo from './components/ProfileInfo.vue';
import SidebarMobile from './components/SidebarMobile.vue';
import { DialogStatus } from './store';
import { find } from 'lodash';

export default {
  name: 'App',
  data() {
    return {
      resId: null,
      isInit: true,
      checkOpenFromBooking: false,
    };
  },
  components: {
    ChatBox,
    Sidebar,
    ProfileInfo,
    SidebarMobile,
  },
  computed: {
    ...mapGetters('profile', ['profile']),
    ...mapGetters('chat', [
      'activeChatCustomer',
      'newMessage',
      'customers',
      'msgId',
      'connect',
    ]),
    ...mapGetters(['dialogStatus']),
    ...mapGetters('contact', ['customerContact']),
    isOnMobile: function() {
      if (!this.activeChatCustomer && this.$store.state.chat.isMobileMode) {
        return true;
      } else if (
        this.activeChatCustomer &&
        this.$store.state.chat.isMobileMode
      ) {
        return false;
      } else {
        return true;
      }
    },
  },
  watch: {
    newMessage: {
      immediate: true,
      handler(message) {
        if (message) {
          if (this.dialogStatus != DialogStatus.OPEN) {
            const customer = find([...this.customers], {
              custId: message.custId,
            });
            var options = {
              icon: customer.custImage,
              body:
                customer.count == 1
                  ? customer.latestMsg
                  : 'มีข้อความใหม่ ' + customer.count + ' ข้อความ',
              requireInteraction: false,
              tag: 'renotify',
              renotify: true,
            };
            var notification = new Notification(message.custName, options);
            setTimeout(notification.close.bind(notification), 5000);
          }
        }
      },
    },
    msgId: {
      immediate: true,
      handler(mesId) {
        if (mesId != null) {
          this.$store.dispatch('chat/sendReadMessage', mesId);
        }
      },
    },
  },
  created() {
    const query = window.location.search.substring(1);
    const vars = query.split('=');
    let onMobile;
    let idRes;
    let Token;
    let custid;
    let SiteTPX;  
    if (vars.length > 0 && vars[0] != '') {
      console.log('vars1 ',this.$route.query.Token);
      console.log('vars2 ',this.$route.query.mobile);
      console.log('vars3 ',this.$route.query.ResId);
      console.log('vars4 ',this.$route.query.custid);
      console.log('vars5 ',this.$route.query.siteurl);
      //idRes = vars[1].replace('&Token', '');
     // Token = vars[2].replace('&mobile', '');
      //onMobile = vars[3] == 'false' ? false : true;
      idRes = this.$route.query.ResId;
      Token = this.$route.query.Token;
      SiteTPX = this.$route.query.siteurl;
      if (Token) {
        localStorage.setItem('token', Token);
      }
      console.log('this.$route.query.siteurl : ', this.$route.query.siteurl);
      console.log('SiteTPX undefined : ', (SiteTPX == undefined));
      if (SiteTPX != undefined) {
          if (SiteTPX == 'office') {
            localStorage.setItem('sitetpx', 'https://m.office.softsq.com/');
          } else {
            localStorage.setItem('sitetpx', 'https://m.tourprox.com/');
          }
        }
      else {
          localStorage.setItem('sitetpx', 'https://m.tourprox.com/');
          console.log('assign sitetpx : ', localStorage.getItem('sitetpx'));
      }
      
      custid = this.$route.query.custid; 
      if (this.$route.query.mobile != undefined){
      onMobile = this.$route.query.mobile.replace('&mobile', '') == 'false' ? false : true;
      } else {
        onMobile = false;
      }
    } else {
      idRes = window.sessionStorage.getItem('resId');
      Token = window.sessionStorage.getItem('token');
      SiteTPX = localStorage.getItem('sitetpx');
      onMobile = window.sessionStorage.getItem('mobile') == 'false' ? false : true;
    }
    if (SiteTPX == undefined) {     
        localStorage.setItem('sitetpx', 'https://m.tourprox.com/');    
    }
    this.$store.dispatch('chat/loadResTeam');    
    console.log('sitetpx : ',localStorage.getItem('sitetpx'));
    window.addEventListener('message', event => {
      if (onMobile == false) {
        window.sessionStorage.setItem('mobile', 'false');
        if (event.data.action == 'SEND_CHATAPP') {
          this.$store.dispatch('setDialogStatus', event.data.data.dialog);
          this.$store.dispatch(
            'setReservationId',
            event.data.data.reservationId,
          );
          if (this.dialogStatus == DialogStatus.CLOSE) {
            if (this.connect == true) {
              this.$store.dispatch('chat/disconnect');
            } else {
              return false;
            }
          }
          if (this.resId == null) {
            this.$store.dispatch('profile/connect').then(() => {
              this.resId = event.data.data.reservationId;
              this.$store.dispatch('profile/loadStatus');
              this.$store.dispatch('profile/loadProfile');
            });
          }
          window.sessionStorage.setItem('resId', event.data.data.reservationId);
        } else {
          if (event.data.action == 'OPEN_CHAT') {
            this.$store.dispatch('chat/setTypeChat', true);
            this.$store.dispatch('setDialogStatus', event.data.data.dialog);
            this.$store.dispatch(
              'setReservationId',
              event.data.data.reservationId,
            );
            this.$store.dispatch('setCusId', event.data.data.custId);
            if (this.resId == null) {
              this.$store.dispatch('profile/connect').then(() => {
                this.resId = event.data.data.reservationId;
                this.$store.dispatch('profile/loadStatus');
                this.$store.dispatch('profile/loadProfile');
              });
            }
          } else {
            return false;
          }
        }
      }
    });
    if (onMobile == true) {
      const reservationId = idRes
        ? idRes
        : window.sessionStorage.getItem('resId');
        console.log('onMobile : ',reservationId);
      if (reservationId && reservationId != null) {
        window.sessionStorage.setItem('resId', reservationId);
        window.sessionStorage.setItem('mobile', 'true');
        this.$store.dispatch('setDialogStatus', 'open');
        this.$store.dispatch('setReservationId', reservationId);
        this.$store.dispatch('profile/connect').then(() => {
          this.resId = reservationId;
          this.$store.dispatch('profile/loadStatus');
          this.$store.dispatch('profile/loadProfile');
        });
      }
    }
    const _token = Token ? Token : window.sessionStorage.getItem('token');
    if (_token && _token != null) {
      window.sessionStorage.setItem('token', _token);
    }
    
    this.$store.dispatch('chat/loadCountTagPaidAndUnpaid');
    window.onresize = () => {
      if (window.innerWidth < 1024 && onMobile == true) {
        if (!this.$store.state.chat.isMobileMode)
          this.$store.commit('chat/IS_MOBILE_MODE', true);
      } else {
        if (this.$store.state.chat.isMobileMode)
          this.$store.commit('chat/IS_MOBILE_MODE', false);
      }
    };
    window.onresize();
    if (custid != undefined) {
      this.$store.dispatch('chat/setTypeChat', true);
      this.$store.dispatch('setDialogStatus', 'active');
      this.$store.dispatch('setCusId', custid);
      console.log('==sssssssssssssssssssssssssssssssssss==');
      this.$store.dispatch('chat/connect').then(() => {
        console.log('================= chat/connect =================');       
        this.$router.push({ path: '/chat', query: { custid: custid } })
      });
    }
  },
};
</script>

<style>
#app {
  zoom: 0.65;
}

@media (max-width: 767px) {
  .ChatBox__Input svg:not(:root).svg-inline--fa {
    display: unset;
  }
}

@media (max-width: 350px) {
  #chatbox {
    display: none;
  }
}
#chatbox.col-lg-12.col-offset-msg.on-mobile {
  padding-left: unset !important;
}
.col-fixed-90 {
  width: 90px;
  position: fixed;
  height: 100%;
  z-index: 1;
}

.col-fixed-listbar {
  margin-left: -10px;
  width: 451px;
  position: fixed;
  height: 100%;
  z-index: 1;
  border-right: 1px solid #eee;
}

.col-offset-msg {
  padding-left: 442px;
  z-index: 0;
}

#chatbox {
  padding-right: 0px;
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.2s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.chat-root {
  height: 100%;
  width: 100%;
  min-height: 300px;
}
.chat-container {
  height: 100%;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue